import { useEffect, useState } from 'react';
import { useIntlayer } from 'react-intlayer';

import { LocalizedLink } from '~/components/LocalizedLink';
import { Menu } from '~/components/Menu';
import { Button } from '~/components/ui/button';
import { HamburgerIcon } from '~/components/ui/HamburgerIcon';
import { ArrowUpRight } from '~/components/ui/icons';
import { SOCIAL_LINKS } from '~/constants';

export const Header = () => {
  const { chorna, tacticalDrones, jade, about, joinTeam } = useIntlayer('header');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    // Check initial scroll position on mount
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  /* Lock body scroll when menu is open */
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  /* Close menu when viewport crosses the md breakpoint (768px) */
  useEffect(() => {
    const mql = window.matchMedia('(min-width: 768px)');
    const handleChange = (e: MediaQueryListEvent) => {
      if (e.matches) setIsMenuOpen(false);
    };
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return (
    <>
      <header
        className={`flex items-center px-4 py-4 md:px-20 md:py-6 w-full fixed top-0 z-50 transition-colors duration-100 ${isScrolled || isMenuOpen ? 'bg-black' : ''} max-w-[1680px] mx-auto`}
      >
        <div className="flex items-center justify-between w-full">
          <LocalizedLink to="/" className="flex items-center shrink-0">
            <img
              src="/assets/images/trypillian-logo-white-horizontal.svg"
              alt="Logo"
              className="h-5 w-auto md:h-6"
            />
          </LocalizedLink>

          {/* Navigation - Desktop only */}
          <nav className="hidden lg:flex items-center gap-3 lg:gap-12">
            <Button variant="tab" asChild>
              <LocalizedLink to="/products/chorna">{chorna}</LocalizedLink>
            </Button>
            <Button variant="tab" asChild>
              <LocalizedLink to="/products/tactical-drones">{tacticalDrones}</LocalizedLink>
            </Button>
            <Button variant="tab" asChild>
              <LocalizedLink to="/products/iris">{jade}</LocalizedLink>
            </Button>
            <Button variant="tab" asChild>
              <LocalizedLink to="/about">{about}</LocalizedLink>
            </Button>
          </nav>

          {/* Right side actions */}
          <div className="flex items-center gap-4">
            {/* Join Team - Desktop only */}
            <Button
              variant="default"
              size="sm"
              className="hidden lg:inline-flex"
              onClick={(e) => {
                e.preventDefault();
                window.open(SOCIAL_LINKS.LINKEDIN, '_blank', 'noopener,noreferrer');
              }}
            >
              {joinTeam}
              <ArrowUpRight />
            </Button>

            <HamburgerIcon isOpen={isMenuOpen} onClick={() => setIsMenuOpen((prev) => !prev)} />

          </div>
        </div>

      </header>

      {/* Menu renders outside header so z-index layers correctly */}
      <Menu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};
